const isPro = process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV !== 'uat'
const isUat = process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV === 'uat'

const proUrl = 'https://ec.ems.com.cn'
const uatUrl = 'https://ecuat.ems.com.cn'

export {
    isPro,
    isUat,
    proUrl,
    uatUrl
}
